import React from "react";
import { LOGO_URL } from "@/lib/brand";

const BrandLogo = ({ className = "w-8 h-8", withText = false, textClass = "" }) => (
  <span className="inline-flex items-center gap-2">
    <img src={LOGO_URL} alt="The Cube Design" className={`${className} object-contain`} data-testid="brand-logo" />
    {withText && <span className={textClass}>The Cube Design</span>}
  </span>
);

export default BrandLogo;
